import type { SVGIconsProps } from "../type";

export function PreferencesIcon({ ...restProps }: SVGIconsProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...restProps}
    >
      <path
        d="M5.55739 7.38281H2"
        stroke="#1D1F20"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.9974 7.38281H10.1406"
        stroke="#1D1F20"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.8577 16.7422H2"
        stroke="#1D1F20"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.0008 16.7422H18.4453"
        stroke="#1D1F20"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.55469 7.25071C5.55469 7.85903 5.79634 8.44244 6.22649 8.87259C6.65664 9.30273 7.24004 9.54439 7.84837 9.54439C8.45669 9.54439 9.04009 9.30273 9.47024 8.87259C9.90039 8.44244 10.142 7.85903 10.142 7.25071C10.142 6.64239 9.90039 6.05898 9.47024 5.62883C9.04009 5.19869 8.45669 4.95703 7.84837 4.95703C7.24004 4.95703 6.65664 5.19869 6.22649 5.62883C5.79634 6.05898 5.55469 6.64239 5.55469 7.25071Z"
        stroke="#1D1F20"
        strokeWidth="1.5"
      />
      <path
        d="M13.8594 16.7468C13.8594 17.3551 14.101 17.9385 14.5312 18.3687C14.9613 18.7988 15.5447 19.0405 16.1531 19.0405C16.7614 19.0405 17.3448 18.7988 17.7749 18.3687C18.2051 17.9385 18.4467 17.3551 18.4467 16.7468C18.4467 16.1385 18.2051 15.5551 17.7749 15.1249C17.3448 14.6948 16.7614 14.4531 16.1531 14.4531C15.5447 14.4531 14.9613 14.6948 14.5312 15.1249C14.101 15.5551 13.8594 16.1385 13.8594 16.7468Z"
        stroke="#1D1F20"
        strokeWidth="1.5"
      />
    </svg>
  );
}
